import { isEmpty } from 'lodash';

import type { TaskProjectManagement } from '@/task-manager/entities/task-project-management';

import type { GetCardDetailViewOutputWorkstreamProjectDetails } from '../fetch-client';

export function taskProjectManagementMapper(
  data: GetCardDetailViewOutputWorkstreamProjectDetails | undefined,
): TaskProjectManagement | undefined {
  if (!data || isEmpty(data)) {
    return undefined;
  }

  return {
    project: {
      id: data.project?.accure_id ?? '',
      title: data.project?.name ?? '',
    },
    workstream: {
      id: data.workstream?.uuid ?? '',
      title: data.workstream?.name ?? '',
    },
  };
}
